export class Raca {
	idRaca: number = null;
	dsRaca: string = null;

	constructor(d?) {
    if (d) {
      this.idRaca = d.idRaca ? d.idRaca : null;
      this.dsRaca = d.dsRaca ? d.dsRaca : null;
    }
  }
}
